import type { Workspace } from '@store/reducers/dashboard/types'
import type React from 'react'

import { MembersList } from './components/MembersList'
import css from './styles.module.css'

interface Props {
  workspace: Workspace
}

export const MemberAvatars: React.FC<Props> = ({ workspace }) => (
  <div className={css.members_wrapper}>
    <MembersList members={workspace.members} />
  </div>
)
